/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FetchRecordsRoot } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * LivechatAgentApi - axios parameter creator
 * @export
 */
export const LivechatAgentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Agent Names
         * @param {FetchRecordsRoot} fetchRecordsRoot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentNames: async (fetchRecordsRoot: FetchRecordsRoot, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchRecordsRoot' is not null or undefined
            assertParamExists('getAgentNames', 'fetchRecordsRoot', fetchRecordsRoot)
            const localVarPath = `/api/v1/livechat/agents/performance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchRecordsRoot, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all agent ids that have LiveChat enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLivechatAgents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/livechat/agents/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all agent ids by user id that have LiveChat enabled
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivechatAgents: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getLivechatAgents', 'userId', userId)
            const localVarPath = `/api/v1/livechat/agents/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated list of LiveChat agent ids (max 10 by default)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginatedLivechatAgents: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/livechat/agents/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Proxy LiveChat agent list from an IP-bound API
         * @param {string} ip Target LiveChat host IP address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyLivechatAgents: async (ip: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ip' is not null or undefined
            assertParamExists('proxyLivechatAgents', 'ip', ip)
            const localVarPath = `/api/v1/proxy/livechat/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ip !== undefined) {
                localVarQueryParameter['ip'] = ip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LivechatAgentApi - functional programming interface
 * @export
 */
export const LivechatAgentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LivechatAgentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Agent Names
         * @param {FetchRecordsRoot} fetchRecordsRoot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentNames(fetchRecordsRoot: FetchRecordsRoot, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentNames(fetchRecordsRoot, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivechatAgentApi.getAgentNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all agent ids that have LiveChat enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLivechatAgents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLivechatAgents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivechatAgentApi.getAllLivechatAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all agent ids by user id that have LiveChat enabled
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLivechatAgents(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLivechatAgents(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivechatAgentApi.getLivechatAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated list of LiveChat agent ids (max 10 by default)
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginatedLivechatAgents(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginatedLivechatAgents(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivechatAgentApi.getPaginatedLivechatAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Proxy LiveChat agent list from an IP-bound API
         * @param {string} ip Target LiveChat host IP address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxyLivechatAgents(ip: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proxyLivechatAgents(ip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivechatAgentApi.proxyLivechatAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LivechatAgentApi - factory interface
 * @export
 */
export const LivechatAgentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LivechatAgentApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Agent Names
         * @param {LivechatAgentApiGetAgentNamesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentNames(requestParameters: LivechatAgentApiGetAgentNamesRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAgentNames(requestParameters.fetchRecordsRoot, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all agent ids that have LiveChat enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLivechatAgents(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAllLivechatAgents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all agent ids by user id that have LiveChat enabled
         * @param {LivechatAgentApiGetLivechatAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivechatAgents(requestParameters: LivechatAgentApiGetLivechatAgentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getLivechatAgents(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated list of LiveChat agent ids (max 10 by default)
         * @param {LivechatAgentApiGetPaginatedLivechatAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginatedLivechatAgents(requestParameters: LivechatAgentApiGetPaginatedLivechatAgentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPaginatedLivechatAgents(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Proxy LiveChat agent list from an IP-bound API
         * @param {LivechatAgentApiProxyLivechatAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyLivechatAgents(requestParameters: LivechatAgentApiProxyLivechatAgentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.proxyLivechatAgents(requestParameters.ip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAgentNames operation in LivechatAgentApi.
 * @export
 * @interface LivechatAgentApiGetAgentNamesRequest
 */
export interface LivechatAgentApiGetAgentNamesRequest {
    /**
     * 
     * @type {FetchRecordsRoot}
     * @memberof LivechatAgentApiGetAgentNames
     */
    readonly fetchRecordsRoot: FetchRecordsRoot
}

/**
 * Request parameters for getLivechatAgents operation in LivechatAgentApi.
 * @export
 * @interface LivechatAgentApiGetLivechatAgentsRequest
 */
export interface LivechatAgentApiGetLivechatAgentsRequest {
    /**
     * 
     * @type {string}
     * @memberof LivechatAgentApiGetLivechatAgents
     */
    readonly userId: string
}

/**
 * Request parameters for getPaginatedLivechatAgents operation in LivechatAgentApi.
 * @export
 * @interface LivechatAgentApiGetPaginatedLivechatAgentsRequest
 */
export interface LivechatAgentApiGetPaginatedLivechatAgentsRequest {
    /**
     * 
     * @type {number}
     * @memberof LivechatAgentApiGetPaginatedLivechatAgents
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof LivechatAgentApiGetPaginatedLivechatAgents
     */
    readonly offset?: number
}

/**
 * Request parameters for proxyLivechatAgents operation in LivechatAgentApi.
 * @export
 * @interface LivechatAgentApiProxyLivechatAgentsRequest
 */
export interface LivechatAgentApiProxyLivechatAgentsRequest {
    /**
     * Target LiveChat host IP address
     * @type {string}
     * @memberof LivechatAgentApiProxyLivechatAgents
     */
    readonly ip: string
}

/**
 * LivechatAgentApi - object-oriented interface
 * @export
 * @class LivechatAgentApi
 * @extends {BaseAPI}
 */
export class LivechatAgentApi extends BaseAPI {
    /**
     * 
     * @summary Get Agent Names
     * @param {LivechatAgentApiGetAgentNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivechatAgentApi
     */
    public getAgentNames(requestParameters: LivechatAgentApiGetAgentNamesRequest, options?: RawAxiosRequestConfig) {
        return LivechatAgentApiFp(this.configuration).getAgentNames(requestParameters.fetchRecordsRoot, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all agent ids that have LiveChat enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivechatAgentApi
     */
    public getAllLivechatAgents(options?: RawAxiosRequestConfig) {
        return LivechatAgentApiFp(this.configuration).getAllLivechatAgents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all agent ids by user id that have LiveChat enabled
     * @param {LivechatAgentApiGetLivechatAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivechatAgentApi
     */
    public getLivechatAgents(requestParameters: LivechatAgentApiGetLivechatAgentsRequest, options?: RawAxiosRequestConfig) {
        return LivechatAgentApiFp(this.configuration).getLivechatAgents(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated list of LiveChat agent ids (max 10 by default)
     * @param {LivechatAgentApiGetPaginatedLivechatAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivechatAgentApi
     */
    public getPaginatedLivechatAgents(requestParameters: LivechatAgentApiGetPaginatedLivechatAgentsRequest = {}, options?: RawAxiosRequestConfig) {
        return LivechatAgentApiFp(this.configuration).getPaginatedLivechatAgents(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Proxy LiveChat agent list from an IP-bound API
     * @param {LivechatAgentApiProxyLivechatAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivechatAgentApi
     */
    public proxyLivechatAgents(requestParameters: LivechatAgentApiProxyLivechatAgentsRequest, options?: RawAxiosRequestConfig) {
        return LivechatAgentApiFp(this.configuration).proxyLivechatAgents(requestParameters.ip, options).then((request) => request(this.axios, this.basePath));
    }
}

